import GenericCookieStrategy from './genericCookieStrategy';

export default class JWTTokenStrategy extends GenericCookieStrategy {
  constructor() {
    super('user-auth-token');
  }
}



// WEBPACK FOOTER //
// ./src/auth/tokenStrategies/jwtTokenStrategy.js